import { render, staticRenderFns } from "./DetalhesCliente.vue?vue&type=template&id=66031b1d&"
import script from "./DetalhesCliente.vue?vue&type=script&lang=js&"
export * from "./DetalhesCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports